import { render, staticRenderFns } from "./MailTemplatesPanel.vue?vue&type=template&id=0016c0b2&scoped=true"
import script from "./MailTemplatesPanel.vue?vue&type=script&lang=js"
export * from "./MailTemplatesPanel.vue?vue&type=script&lang=js"
import style0 from "./MailTemplatesPanel.vue?vue&type=style&index=0&id=0016c0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016c0b2",
  null
  
)

export default component.exports